var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Group 27021",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.907,
    x2: 0.163,
    y1: 0.227,
    y2: 0.853,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6509e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ebac6"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#a)",
    "data-name": "Ellipse 991"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.251 16.78-4.059-9.809a1.091 1.091 0 0 0-1.017-.755h-.359a1.091 1.091 0 0 0-1.017.755l-1.766 4.274H7.697a.731.731 0 0 0-.728.725v.01a.731.731 0 0 0 .728.725h.718L6.73 16.78a.86.86 0 0 0-.05.278.767.767 0 0 0 .2.547.7.7 0 0 0 .539.209.729.729 0 0 0 .419-.139.885.885 0 0 0 .289-.368l1.853-4.601h1.287a.731.731 0 0 0 .728-.725v-.02a.731.731 0 0 0-.728-.725h-.687l1.415-3.529 3.859 9.6a.885.885 0 0 0 .289.368.729.729 0 0 0 .419.139.7.7 0 0 0 .539-.209.767.767 0 0 0 .2-.547.657.657 0 0 0-.05-.278z",
    "data-name": "Path 2434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAave);
export default __webpack_public_path__ + "static/media/aave.4993038fd95d17c5d475fa8e60af75ab.svg";
export { ForwardRef as ReactComponent };